import { createAccountRoute } from "~/features/account";
import { createClientRoute } from "~/features/client";
import {
  createClientRoute as createAdminClientRoute,
  createCreateClientRoute,
} from "~/features/client/admin";
import { createClientFeesRoute } from "~/features/client_fees";
import { createClientFeesRoute as createAdminClientFeesRoute } from "~/features/client_fees/admin";
import { createClientsRoute } from "~/features/clients/admin";
import { createKycRoute } from "~/features/kyc";
import { AppLayout } from "~/features/layout";
import { createClientPayoutDetailsRoute } from "~/features/payout_details";
import { createAdminPayoutDetailsRoute } from "~/features/payout_details/admin";
import { createAdminPayoutsRoute } from "~/features/payouts/admin";
import { createRootRoute } from "~/features/root";
import {
  createF2fTransactionRoute,
  createOnlineTransactionRoute,
} from "~/features/transaction";
import {
  createAdminF2fTransactionRoute,
  createAdminOnlineTransactionRoute,
  createAdminV2TransactionRoute,
} from "~/features/transaction/admin";
import { createTransactionsRoute } from "~/features/transactions";
import { createAdminTransactionsRoute } from "~/features/transactions/admin";

const RootRoute = createRootRoute(AppLayout);

const AccountRoute = createAccountRoute(RootRoute);
const ClientRoute = createClientRoute(RootRoute);
const ClientTransactionsRoute = createTransactionsRoute(RootRoute);

const F2fTransactionRoute = createF2fTransactionRoute(RootRoute);
const OnlineTransactionRoute = createOnlineTransactionRoute(RootRoute);

// Admin routes.
const AdminClientsRoute = createClientsRoute(RootRoute);
const AdminClientRoute = createAdminClientRoute(RootRoute);
const AdminCreateClientRoute = createCreateClientRoute(RootRoute);

const AdminF2fTransactionRoute = createAdminF2fTransactionRoute(RootRoute);
const AdminOnlineTransactionRoute =
  createAdminOnlineTransactionRoute(RootRoute);
const AdminV2TransactionRoute = createAdminV2TransactionRoute(RootRoute);
const AdminTransactionsRoute = createAdminTransactionsRoute(RootRoute);

const AdminClientFeesRoute = createAdminClientFeesRoute(RootRoute);
const ClientFeesRoute = createClientFeesRoute(RootRoute);

const AdminPayoutDetailsRoute = createAdminPayoutDetailsRoute(RootRoute);
const AdminPayoutsRoute = createAdminPayoutsRoute(RootRoute);
const ClientPayoutDetailsRoute = createClientPayoutDetailsRoute(RootRoute);

const KycRoute = createKycRoute(RootRoute);

export const routeTree = RootRoute.addChildren([
  AdminCreateClientRoute,
  AdminClientsRoute,
  AdminClientRoute,
  AdminClientFeesRoute,
  AdminTransactionsRoute,
  AdminF2fTransactionRoute,
  AdminOnlineTransactionRoute,
  AdminV2TransactionRoute,
  AdminPayoutDetailsRoute,
  AdminPayoutsRoute,
  F2fTransactionRoute,
  OnlineTransactionRoute,
  AccountRoute,
  ClientRoute,
  ClientTransactionsRoute,
  ClientFeesRoute,
  ClientPayoutDetailsRoute,
  KycRoute,
]);
